"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniverseAPI = void 0;
var api_client_1 = __importDefault(require("../api-client"));
var universe_constants_1 = require("./universe.constants");
var UniverseAPI = /** @class */ (function () {
    function UniverseAPI() {
    }
    UniverseAPI.create = function (payload) {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.CREATE, payload);
    };
    UniverseAPI.getInfo = function () {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.GET_INFO, {});
    };
    UniverseAPI.updateUiSettings = function (payload) {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.SET_UI_SETTINGS, payload);
    };
    UniverseAPI.updateUiConfiguration = function (payload) {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.SET_UI_CONFIGURATION, payload);
    };
    UniverseAPI.fetchUiConfiguration = function (payload) {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.GET_UI_CONFIGURATION, payload);
    };
    UniverseAPI.fetchUniverses = function () {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.GET_ALL, {});
    };
    UniverseAPI.fetchByFilter = function (payload) {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.GET_BY_FILTER, payload);
    };
    UniverseAPI.validateUniquenessDomain = function (domain) {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.VALIDATE_UNIQUENESS_DOMAIN, { domain: domain });
    };
    UniverseAPI.validateUniquenessName = function (name) {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.VALIDATE_UNIQUENESS_NAME, { name: name });
    };
    UniverseAPI.getMine = function () {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.GET_MINE, {});
    };
    UniverseAPI.updateAffiliate = function (payload) {
        return api_client_1.default.post(universe_constants_1.UNIVERSE_API_URLS.SET_AFFILIATE, payload);
    };
    return UniverseAPI;
}());
exports.UniverseAPI = UniverseAPI;
